// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"673a2bcd","258":"3d0f3dd8","455":"adfc305d","895":"6f79a9b7","977":"dfcb9f87"}[chunkId] + ".chunk.js";
};